import React from 'react'
import { InfoIcon, SortArrowUpIcon, SortArrowDownIcon } from '../Icons'
import './index.sass'

const MarketsTableHeader = ({ columns, sortBy, sortDirection, onSort }) => {
  // Функція для обробки тексту: якщо це "24h Change", ми обгортаємо "Change" у span
  const renderLabel = (label) => {
    if (label === '24h Change') {
      return (
        <>
          24h <span className="markets-table-header__label-word-hide">Change</span>
        </>
      )
    }
    return label
  }

  return (
    <thead className="markets-table-header">
      <tr>
        {columns.map((column) => {
          const isSortable = column.sortable
          const isActive = isSortable && sortBy === column.key
          const isAsc = isActive && sortDirection === 'asc'

          const handleClick = () => {
            if (!isSortable) return
            onSort(column.key)
          }

          return (
            <th
              key={column.key}
              className={`markets-table-header__cell markets-table-header__cell--${column.key} ${
                column.align === 'right' ? 'markets-table-header__cell--align-right' : ''
              }`}
            >
              <button
                type="button"
                className={`markets-table-header__button ${isSortable ? 'markets-table-header__button--sortable' : ''}`}
                onClick={handleClick}
              >
                <span className="markets-table-header__label">
                  {renderLabel(column.label)}
                </span>
                
                {isSortable && (
                  <span className="markets-table-header__sort" aria-hidden>
                    <span className={`markets-table-header__sort-arrow markets-table-header__sort-arrow--up ${isActive && isAsc ? 'markets-table-header__sort-arrow--active' : ''}`}>
                      <SortArrowUpIcon />
                    </span>
                    <span className={`markets-table-header__sort-arrow markets-table-header__sort-arrow--down ${isActive && !isAsc ? 'markets-table-header__sort-arrow--active' : ''}`}>
                      <SortArrowDownIcon />
                    </span>
                  </span>
                )}
                
                {column.info && (
                  <span className="markets-table-header__info" aria-hidden>
                    <InfoIcon />
                  </span>
                )}
              </button>
            </th>
          )
        })}
      </tr>
    </thead>
  )
}

export default MarketsTableHeader